import { defineRouting } from "next-intl/routing";
import { DEFAULT_LOCALE, LIVE_LOCALE_CODES } from "@wmart/i18n";

// Live storefront locales drive routing. localePrefix 'always' → every locale
// is prefixed (incl. /en), so URLs are symmetric for hreflang + sitemap and
// `/` redirects to `/en`. Adding a locale = flipping its `enabled` flag in
// @wmart/i18n (Phase 4).
export const routing = defineRouting({
  locales: LIVE_LOCALE_CODES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: "always",
});
